// String manipulation utilities for the Aquaduct web frontend.
// These helpers handle common formatting operations like ID shortening.

/**
 * Checks if a string contains only hexadecimal characters.
 */
export const isHexString = (str: string): boolean => /^[0-9a-fA-F]*$/.test(str);

/**
 * Shortens tunnel names that appear to be auto-generated hex IDs.
 * If the name is exactly 20 hex characters, shows first 7 chars with ellipsis.
 */
export const shortenTunnelName = (name: string): string => {
    if (name.length === 20 && isHexString(name)) {
        return `${name.substring(0, 7)}...`;
    }
    return name;
};

/**
 * Shortens instance IDs to their first 4 characters for display.
 */
export const shortenInstanceId = (id: string): string => id.substring(0, 4);
